import { aboutContent } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-10">
          {aboutContent.title}
        </h2>
        <div className="bg-background-100 border border-background-200/30 rounded-xl p-6 md:p-10">
          <div className="space-y-5">
            {aboutContent.paragraphs.map((p, idx) => (
              <p key={idx} className="text-foreground-300 text-sm md:text-base leading-relaxed">
                {p}
              </p>
            ))}
          </div>
          <div className="mt-8 grid grid-cols-3 gap-6 text-center">
            <div>
              <p className="text-primary-500 text-3xl font-bold font-heading">10万+</p>
              <p className="text-foreground-500 text-xs mt-1">影视资源</p>
            </div>
            <div>
              <p className="text-primary-500 text-3xl font-bold font-heading">2018</p>
              <p className="text-foreground-500 text-xs mt-1">创立年份</p>
            </div>
            <div>
              <p className="text-primary-500 text-3xl font-bold font-heading">5000万+</p>
              <p className="text-foreground-500 text-xs mt-1">累计用户</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}